/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPTRANSFERMETHOD } from './IAPTRANSFERMETHOD';
import {
    IAPTRANSFERMETHODFromJSON,
    IAPTRANSFERMETHODFromJSONTyped,
    IAPTRANSFERMETHODToJSON,
} from './IAPTRANSFERMETHOD';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';
import type { InvestmentDetailsSourceOfMoneySplitViewModel } from './InvestmentDetailsSourceOfMoneySplitViewModel';
import {
    InvestmentDetailsSourceOfMoneySplitViewModelFromJSON,
    InvestmentDetailsSourceOfMoneySplitViewModelFromJSONTyped,
    InvestmentDetailsSourceOfMoneySplitViewModelToJSON,
} from './InvestmentDetailsSourceOfMoneySplitViewModel';

/**
 * 
 * @export
 * @interface InvestmentDetailsCashTransferViewModel
 */
export interface InvestmentDetailsCashTransferViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsCashTransferViewModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsCashTransferViewModel
     */
    amount?: number;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof InvestmentDetailsCashTransferViewModel
     */
    hasCashTransfer: IAPYESORNO;
    /**
     * 
     * @type {IAPTRANSFERMETHOD}
     * @memberof InvestmentDetailsCashTransferViewModel
     */
    transferMethodId?: IAPTRANSFERMETHOD;
    /**
     * 
     * @type {InvestmentDetailsSourceOfMoneySplitViewModel}
     * @memberof InvestmentDetailsCashTransferViewModel
     */
    sourceOfMoneySplit?: InvestmentDetailsSourceOfMoneySplitViewModel;
}

/**
 * Check if a given object implements the InvestmentDetailsCashTransferViewModel interface.
 */
export function instanceOfInvestmentDetailsCashTransferViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "hasCashTransfer" in value;

    return isInstance;
}

export function InvestmentDetailsCashTransferViewModelFromJSON(json: any): InvestmentDetailsCashTransferViewModel {
    return InvestmentDetailsCashTransferViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsCashTransferViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsCashTransferViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'amount': !exists(json, 'Amount') ? undefined : json['Amount'],
        'hasCashTransfer': IAPYESORNOFromJSON(json['HasCashTransfer']),
        'transferMethodId': !exists(json, 'TransferMethodId') ? undefined : IAPTRANSFERMETHODFromJSON(json['TransferMethodId']),
        'sourceOfMoneySplit': !exists(json, 'SourceOfMoneySplit') ? undefined : InvestmentDetailsSourceOfMoneySplitViewModelFromJSON(json['SourceOfMoneySplit']),
    };
}

export function InvestmentDetailsCashTransferViewModelToJSON(value?: InvestmentDetailsCashTransferViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'Amount': value.amount,
        'HasCashTransfer': IAPYESORNOToJSON(value.hasCashTransfer),
        'TransferMethodId': IAPTRANSFERMETHODToJSON(value.transferMethodId),
        'SourceOfMoneySplit': InvestmentDetailsSourceOfMoneySplitViewModelToJSON(value.sourceOfMoneySplit),
    };
}

